<template>
  <div>
    <b-modal
      id="modal-edit"
      size="lg"
      centered
      :title="$store.state.modal.editRoleUser"
      header-bg-variant="warning"
      header-text-variant="light"
      @show="showModal"
    >
      <b-form>
        <b-form-group label="User" label-cols-md="3">
          <Multiselect
            class="w-100"
            v-model="data.user"
            :options="listUser"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="username"
            track-by="id"
            placeholder="-- pilih user --"
            @input="getMitra(data.user)"
          ></Multiselect>
        </b-form-group>
        <b-form-group label="Role" label-cols-md="3">
          <Multiselect
            class="w-100"
            v-model="data.role"
            :options="listRole"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaRole"
            track-by="id"
            placeholder="-- pilih role --"
          ></Multiselect>
        </b-form-group>
        <b-form-group label="Mitra" label-cols-md="3">
          <Multiselect
            class="w-100"
            v-model="data.mitra"
            :options="listMitra"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaMitra"
            track-by="id"
            placeholder="-- pilih mitra --"
            @input="getKoordinator(data.mitra), data.koordinator = null, data.cabang = null, data.capem = null, listKoordinator = [], listCabang = [], listCapem = []"
            disabled
          ></Multiselect>
        </b-form-group>
        <b-form-group label="Koordinator" label-cols-md="3">
          <Multiselect
            class="w-100"
            v-model="data.koordinator"
            :options="listKoordinator"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaKoordinator"
            track-by="id"
            placeholder="-- pilih koordinator --"
            @input="getCabang(data.koordinator), data.cabang = null, data.capem = null, listCabang = [], listCapem = []"
          ></Multiselect>
        </b-form-group>
        <b-form-group label="Cabang" label-cols-md="3">
          <Multiselect
            class="w-100"
            v-model="data.cabang"
            :options="listCabang"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaCabang"
            track-by="id"
            placeholder="-- pilih cabang --"
            @input="getCapem(data.cabang), data.capem = null, listCapem = []"
          ></Multiselect>
        </b-form-group>
        <b-form-group label="Capem" label-cols-md="3">
          <Multiselect
            class="w-100"
            v-model="data.capem"
            :options="listCapem"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaCapem"
            track-by="id"
            placeholder="-- pilih capem --"
          ></Multiselect>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-edit')">
          {{ $store.state.form.batal }}
        </b-button>
        <b-button
          variant="primary"
          :disabled="busy || !isValid"
          @click="simpan()"
        >
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
  name: "modalEdit",
  props: [ 'data', 'listUser', 'listRole', 'listMitra'],
  data() {
    return {
      listKoordinator: [],
      listCabang: [],
      listCapem: [],
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    ...mapGetters(["lang"]),
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      user: { required },
      role: { required },
      mitra: {
        required: requiredIf(function () {
          return this.data && this.data.role && this.data.role.kodeRole == 'super_user'
        }),
      },
      koordinator: {  },
      cabang: {  },
      capem: {  },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    showModal(){
      const vm = this
      // vm.getMitra(vm.data.user)
      vm.getKoordinator(vm.data.mitra)
      vm.getCabang(vm.data.koordinator)
      vm.getCapem(vm.data.cabang)
    },
    async getMitra(x){
      const vm = this
      if(x){
        vm.data.mitra = null
        vm.data.koordinator = null
        vm.data.cabang = null
        vm.data.capem = null
        vm.listKoordinator = []
        vm.listCabang = []
        vm.listCapem = []
        for (let i = 0; i < vm.listMitra.length; i++) {
          const item = vm.listMitra[i];
          if(item.id == x.mitraId){
            vm.data.mitra = item
            vm.getKoordinator(item)
            break;
          }
        }
      }
    },
    async getKoordinator(x){
      const vm = this
      if(x){
        let listKoordinator = await vm.$axios('koordinator/listKoordinatorByMitraId/' + x.id)
        // console.log('listKoordinator', listKoordinator)
        vm.listKoordinator = listKoordinator.data.status == 200 ? listKoordinator.data.data : []
      }
    },
    async getCabang(x){
      const vm = this
      if(x){
        let listCabang = await vm.$axios('cabang/listCabangByKoordinatorId/' + x.id)
        // console.log('listCabang', listCabang)
        vm.listCabang = listCabang.data.status == 200 ? listCabang.data.data : []
      }
    },
    async getCapem(x){
      const vm = this
      if(x){
        let listCapem = await vm.$axios('capem/listCapemByCabangId/' + x.id)
        // console.log('listCapem', listCapem)
        vm.listCapem = listCapem.data.status == 200 ? listCapem.data.data : []
      }
    },
    simpan() {
      let vm = this;
      if (vm.isValid) {
        vm.busy = true;
        vm.data.id = vm.data.poolRoleId
        vm.data.masterUserId = vm.data.user.id
        vm.data.roleId = vm.data.role.id
        vm.data.mitraId = vm.data.mitra ? vm.data.mitra.id : null
        vm.data.koordinatorId = vm.data.koordinator ? vm.data.koordinator.id : null
        vm.data.cabangId = vm.data.cabang ? vm.data.cabang.id : null
        vm.data.capemId = vm.data.capem ? vm.data.capem.id : null
        vm.button = vm.$store.state.form.tunggu;
        vm.$axios
          .post("poolRole/update", vm.data)
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.button = vm.$store.state.form.simpan;
              vm.busy = false;
              this.$v.$reset();
              vm.$emit("alertFromChild", {
                variant: "success",
                msg: "BERHASIL MENGUBAH DATA MASTER ROLE USER",
                showing: true,
              });
              this.$bvModal.hide("modal-edit");
            } else {
              vm.button = vm.$store.state.form.simpan;
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          })
          .catch((err) => {
            vm.button = vm.$store.state.form.simpan;
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: err.message.toUpperCase(),
              showing: true,
            });
          });
      }
    },
  },
  watch: {
    lang: function (val) {
      val;
      this.button = this.$store.state.form.simpan;
    },
  },
};
</script>
